<app-module-header [title]="organization.organizationName + ' - ' + ('SETTINGS.SETTINGS' | transloco)" icon="settings"></app-module-header>
